<button
  *ngIf="showCopyLabel"
  type="button"
  (click)="copyEvent.emit()"
  class="adap-btn-blank copy-button"
>
  <mat-icon class="copy-icon">content_copy</mat-icon>
</button>
<quill-view [content]="content" [format]="format" theme="snow" />
